import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { ThemeProvider, useTheme } from '@/contexts/ThemeContext';
import Layout from '@/components/Layout';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import AccountsPayablePage from '@/pages/AccountsPayablePage';
import AccountsReceivablePage from '@/pages/AccountsReceivablePage';
import PurchaseOrdersPage from '@/pages/PurchaseOrdersPage';
import PaymentsPage from '@/pages/PaymentsPage';
import ClientsPage from '@/pages/ClientsPage';
import EmailSettingsPage from '@/pages/EmailSettingsPage';
import CompanySettingsPage from '@/pages/CompanySettingsPage';
import VendorUploadPage from '@/pages/VendorUploadPage';
import AdminPage from '@/pages/AdminPage';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-muted-foreground text-sm">Loading...</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AuthRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster theme={theme} richColors position="top-right" />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<AuthRoute><LoginPage /></AuthRoute>} />
            <Route path="/vendor-upload/:token" element={<VendorUploadPage />} />
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<DashboardPage />} />
              <Route path="accounts-payable" element={<AccountsPayablePage />} />
              <Route path="accounts-receivable" element={<AccountsReceivablePage />} />
              <Route path="purchase-orders" element={<PurchaseOrdersPage />} />
              <Route path="payments" element={<PaymentsPage />} />
              <Route path="contacts" element={<ClientsPage />} />
              <Route path="email-settings" element={<EmailSettingsPage />} />
              <Route path="company-settings" element={<CompanySettingsPage />} />
              <Route path="admin" element={<AdminPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <ThemedToaster />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
